/** @format */

export const dummyWidget = [
  {
    i: '1',
    type: 'academy_training',
    size: 'normal',
    title: 'Trainings'
  },
  {
    i: '2',
    type: 'academy_training',
    size: 'medium',
    title: 'Trainings'
  },
  {
    i: '22',
    type: 'academy_training',
    size: 'medium',
    title: 'Trainings'
  },
  {
    i: '3',
    type: 'academy_training',
    size: 'large',
    title: 'Trainings'
  },
  {
    i: '4',
    type: 'academy_training',
    size: 'wide',
    title: 'Trainings'
  },
  {
    i: '5',
    type: 'academy_training',
    size: 'xwide',
    title: 'Trainings'
  },
  {
    i: '6',
    type: 'academy_training',
    size: '2xl',
    title: 'Trainings'
  }
];
